import FlashcardsAPI from "@/services/api/flashcards"
import { useQuery } from "@tanstack/react-query"

const useGetFlashcard = (flashcardId: string) => {
  const query = useQuery({
    queryKey: ["get-flashcard", flashcardId],
    queryFn: () => FlashcardsAPI.get(flashcardId),
    enabled: !!flashcardId,
  })

  return query
}

export default useGetFlashcard
